import type { ThemeOptions } from '@mui/material'
import { commonPaletteColors } from './palette-common'

/**
 * NOTE: Please consider adding the new colors and palette section at the end of file
 *       Preventing design team conflicts
 * TODO: Theme has some invalid color values starting with #
 */
export const darkGlassPalette: ThemeOptions['palette'] = {
  // NOTE: Do not override global theme for partial theme changes, make the type inference easier
  mode: 'dark',
  background: {
    default: '#15263F7A',
    paper: '#0D17267A',
  },
  text: {
    primary: '#CDE1FEFA',
    secondary: '#CDE1FEA3',
    tertiary: '#CDE2FE7A',
    disabled: '#CDE1FE52',
  },
  line: {
    primary: '#CDE2FE14',
    secondary: '#CDE2FE3D',
    tertiary: '#CDE2FE80',
  },
  primary: {
    lighter: '#1C2B3F',
    light: '#93A6C0',
    main: '#E5F0FF',
    dark: '#FAFCFF',
    darker: '#FFFFFF',
    overlay: '#143666',
  },
  secondary: {
    lighter: '#15263F',
    light: '#4377C0',
    main: '#599EFF',
    dark: '#73ADFF',
    darker: '#EEF5FF',
    overlay: '#09101A',
  },
  success: {
    lighter: '#66CCAA14',
    light: '#66CCAAB2',
    main: '#66CCAA',
    dark: '#-',
    darker: '#-',
    overlay: '#0D1A15',
  },
  error: {
    lighter: '#F5627B14',
    light: '#F5627BB2',
    main: '#F5627B',
    dark: '-',
    darker: '-',
    overlay: '#1A0A0D',
  },
  warning: {
    lighter: '#F5AD4914',
    light: '#F5AD49B2',
    main: '#F5AD49',
    dark: '#F8C680',
    darker: '#FEF7ED',
    overlay: '#1A1208',
  },
  info: {
    lighter: '#599EFF14',
    light: '#599EFFB2',
    main: '#599EFF',
    dark: '#73ADFF',
    darker: '#EEF5FF',
    overlay: '#09101A',
  },
  tertiary: {
    lighter: '#FFF0E4',
    light: '#FFF0E4',
    main: '#E26C2B',
    dark: '#E26C2B',
    darker: '#E26C2B',
    overlay: '#FFF0E4',
    contrastText: "#ffffff",
  },
  common: commonPaletteColors,
}
